/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChatEventDirectChatCreatedContentDto { 
    /**
     * id чата
     */
    chatId: string;
    /**
     * id пользователя, кто создал
     */
    creatorUserId: string;
    /**
     * Имя пользователя, кто создал
     */
    creatorUserName: string;
    /**
     * Признак, что у создателя есть аватарка
     */
    creatorAvatarExists: boolean;
    /**
     * id пользователя, с кем создан директ-чат
     */
    anotherUserId: string;
    /**
     * Имя пользователя, с кем создан директ-чат
     */
    anotherUserName: string;
    /**
     * Признак, что у собеседника есть аватарка
     */
    anotherUserAvatarExists: boolean;
}

